import { axios } from '@/lib/utils/axios';
import type { DamagePolygonSuccessResponseType } from '@/common/damage-polygon';
import { API_URLS } from '../query.client';
import { getResponse } from '../common';

export async function getDamagePolygonById(
	id: string | number
): Promise<DamagePolygonSuccessResponseType | null> {
	// Appending the ID to the base index URL
	const url = `${API_URLS.DAMAGE_POLYGONS.INDEX}/${id}`;

	const response = await axios.get(url);

	return getResponse<DamagePolygonSuccessResponseType>(response.data);
}
